module.exports = ":host {\n  position: relative; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/personal-details/steps/basic-info/basic-info-screen.component.scss
// module id = 1442
// module chunks = 0